/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

import { TableHeader } from 'src/components/pageable-table';

export const PullRequestTableHeader = styled(TableHeader)(
  media.upToLarge(`
    display: none;
  `)
);

export const BuildsTableHeader = styled(TableHeader)(
  media.upToLarge(`
    overflow: visible;
  `)
);

export const ActionsTableHeader = styled(TableHeader)({
  width: `${gridSize() * 8}px`,
});

export const BranchSelectionHeader = styled(TableHeader)(
  media.upToMedium(`
    width: 4%;
  `),
  media.upToSmall(`
    width: 5%;
  `)
);

export const BuildsHeaderWrapper = styled.span(
  media.upToMedium(`
    margin-left: -${gridSize()}px;
  `),
  media.upToSmall(`
    margin-left: -${gridSize() * 2}px;
  `)
);
